export interface CpuInfo {
  cpuModel?: string;
  cpuCores?: number;
  cpuThreads?: number;
}

export function shortCpuModel(model?: string): string {
  if (!model) return '';
  return model
    .replace(/\((R|TM|C)\)/gi, '')
    .replace(/\bCPU\b/gi, '')
    .replace(/\d+-Core Processor/gi, '')
    .replace(/\bProcessor\b/gi, '')
    .replace(/@.*/, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function cpuLabel(n: CpuInfo): string | null {
  const parts: string[] = [];
  const model = shortCpuModel(n.cpuModel);
  if (model) parts.push(model);
  if (n.cpuCores || n.cpuThreads) {
    parts.push(`${n.cpuCores ?? '?'}C/${n.cpuThreads ?? '?'}T`);
  }
  return parts.length ? parts.join(' · ') : null;
}
